export const SELECT_STATEMENT_DATE = 'statement/SELECT_STATEMENT_DATE'
export const SET_STATEMENT_DATE = 'statement/SET_STATEMENT_DATE'

export const GET_STATEMENT_REQUEST = 'statement/GET_STATEMENT_REQUEST'
export const GET_STATEMENT_SUCCESS = 'statement/GET_STATEMENT_SUCCESS'
export const GET_STATEMENT_FAILURE = 'statement/GET_STATEMENT_FAILURE'
export const LOAD_STATEMENT_PAGE = 'statement/LOAD_STATEMENT_PAGE'
